import { searchTag, searchTagCenter } from './search-tag-mixins';

export function getSearchTagMixin(isSearchCenter) {
    if (isSearchCenter) {
        return searchTagCenter;
    } else {
        return searchTag;
    }
}